import { SimulazioniSrlDataClass } from "../states/SimulazioneSrlState";
import { getValue } from "./commonFunctions";

export function fillDataPFTelematicoToConvenienza(societaPI: Map<string, string>, state: SimulazioniSrlDataClass) {

    // let primoCF: Map<string, string> = res;
    console.log('primoCF is ' + JSON.stringify(societaPI))
    if (societaPI === null || societaPI === undefined) {
        console.log('società undefined');
        return;
    }
    console.log('primoCF length ' + societaPI.size)
    //Contributi di Imposta
    // console.log('Tipologia impresa ricavo con valore: ' + Number(primoCF["RG002002"]));
    state.datiSimulazioniSrl.K62 = getValue("RF004001", societaPI)
    state.datiSimulazioniSrl.K63 = getValue("RF032001", societaPI)
    state.datiSimulazioniSrl.K64 = getValue("RF056001", societaPI)
}

export function fillDataSocioTelematicoToConvenienza(collabCF: Map<string, string>, state: SimulazioniSrlDataClass, tipoSocio: number)  {

    if (collabCF === null || collabCF === undefined) {
        return;
    }
    console.log('Collab avente tipo ' + tipoSocio + ' is: ' + JSON.stringify(collabCF))
    if (tipoSocio === 1) {
        // Pensione
        state.datiSimulazioniSrl.E118 = getValue("RC001001", collabCF) === 1 ? (getValue("RC001003", collabCF) + getValue("RC002003", collabCF) + getValue("RC003003", collabCF)) : 0
        // Lavoro dip e assimilati
        state.datiSimulazioniSrl.E119 = getValue("RC001001", collabCF) === 1 ? getValue("RC005005", collabCF) - getValue("RC001003", collabCF) - getValue("RC002003", collabCF) - getValue("RC003003", collabCF) : 0
        // Assimilati lav dipendente
        state.datiSimulazioniSrl.E120 = getValue("RC009001", collabCF)
        // TODO, FIXME Impresa minore/lavoro  autonomo
        state.datiSimulazioniSrl.E121 = getImpresaMinoreLavAutonomo(collabCF)
        //Diverse lettere...        
        state.datiSimulazioniSrl.E122 = getValue("RL014002", collabCF) - getValue("RA014003", collabCF) + getValue("RL016002", collabCF) - getValue("RA016003", collabCF)
        state.datiSimulazioniSrl.E123 = getValue("RB010013", collabCF)
        //TODO Altri
        state.datiSimulazioniSrl.E124 = getAltri(collabCF)
        
        state.datiSimulazioniSrl.E125 = getValue("RB010018", collabCF)
        //Redditi a cedolare Secca
        state.datiSimulazioniSrl.E127 = getRedditiCedolareSecca(collabCF)
        
        // Familiari a carico
        // state.datiSimulazioniSrl.H119 = (getValue("FA001001", collabCF) != null || getValue("FA001005", collabCF) != null);
        //Figli NO, max è 4 calcolo un po' complesso
        // state.datiSimulazioniSrl.J119 = getNumeroFigli(collabCF)
        // % è lo stesso valore 
        state.datiSimulazioniSrl.L119 = getValue("FA002007", collabCF)
        //Oneri deducibili RN003001 - RN021001
        state.datiSimulazioniSrl.L121 = getValue("RN003001", collabCF) - getValue("RN021001", collabCF)
        //Detrazioni per oneri
        state.datiSimulazioniSrl.L122 = getValue("RN022001", collabCF) + getValue("RN023001", collabCF) - getValue("RN008001", collabCF)
        //TODO Soggetto a Contribuzione ivs
        //state.datiSimulazioniSrl.J124 = getContribuzioneIvs(collabCF)
        //Ulteriore redditi di impresa per 
        state.datiSimulazioniSrl.J125 = getValue("RR002003", collabCF) - getValue("RR001003", collabCF)
    } else if (tipoSocio === 2) {
        // Pensione
        state.datiSimulazioniSrl.E133 = getValue("RC001001", collabCF) === 1 ? (getValue("RC001003", collabCF) + getValue("RC002003", collabCF) + getValue("RC003003", collabCF)) : 0
        // Lavoro dip e assimilati
        state.datiSimulazioniSrl.E134 = getValue("RC001001", collabCF) === 1 ? getValue("RC005005", collabCF) - getValue("RC001003", collabCF) - getValue("RC002003", collabCF) - getValue("RC003003", collabCF) : 0
        // Assimilati lav dipendente
        state.datiSimulazioniSrl.E135 = getValue("RC009001", collabCF)
        // TODO Impresa minore/lavoro  autonomo
        state.datiSimulazioniSrl.E136 = getImpresaMinoreLavAutonomo(collabCF)
        //Diverse lettere...        
        state.datiSimulazioniSrl.E137 = getValue("RL014002", collabCF) - getValue("RA014003", collabCF) + getValue("RL016002", collabCF) - getValue("RA016003", collabCF)
        state.datiSimulazioniSrl.E138 = getValue("RB010013", collabCF)
        //TODO Altri
        state.datiSimulazioniSrl.E139 = getAltri(collabCF)
        
        state.datiSimulazioniSrl.E140 = getValue("RB010018", collabCF)
        //Redditi a cedolare Secca
        state.datiSimulazioniSrl.E142 = getRedditiCedolareSecca(collabCF)
        
        // Familiari a carico
        // state.datiSimulazioniSrl.H134 = (getValue("FA001001", collabCF) != null || getValue("FA001005", collabCF) != null);
        //Figli, max è 4 calcolo un po' complesso
        //state.datiSimulazioniSrl.J134 = getNumeroFigli(collabCF)
        // % è lo stesso valore 
        state.datiSimulazioniSrl.L134 = getValue("FA002007", collabCF)

        //Oneri deducibili RN023001 - RN021001
        state.datiSimulazioniSrl.L136 = getValue("RN003001", collabCF) - getValue("RN021001", collabCF)
        //Detrazioni per oneri
        state.datiSimulazioniSrl.L137 = getValue("RN022001", collabCF) + getValue("RN023001", collabCF) - getValue("RN008001", collabCF)
        //TODO Soggetto a Contribuzione ivs
        // state.datiSimulazioniSrl.J139 = getContribuzioneIvs(collabCF)
        //Ulteriore redditi di impresa per 
        state.datiSimulazioniSrl.J140 = getValue("RR002003", collabCF) - getValue("RR001003", collabCF)
    
    } else if (tipoSocio === 3) {
        // Pensione
        state.datiSimulazioniSrl.E147 = getValue("RC001001", collabCF) === 1 ? (getValue("RC001003", collabCF) + getValue("RC002003", collabCF) + getValue("RC003003", collabCF)) : 0
        // Lavoro dip e assimilati
        state.datiSimulazioniSrl.E148 = getValue("RC001001", collabCF) === 1 ? getValue("RC005005", collabCF) - getValue("RC001003", collabCF) - getValue("RC002003", collabCF) - getValue("RC003003", collabCF) : 0
        // Assimilati lav dipendente
        state.datiSimulazioniSrl.E149 = getValue("RC009001", collabCF)
        // TODO Impresa minore/lavoro  autonomo
        state.datiSimulazioniSrl.E150 = getImpresaMinoreLavAutonomo(collabCF)
        //Diverse lettere...
        state.datiSimulazioniSrl.E151 = getValue("RL014002", collabCF) - getValue("RA014003", collabCF) + getValue("RL016002", collabCF) - getValue("RA016003", collabCF)
        state.datiSimulazioniSrl.E152 = getValue("RB010013", collabCF)
        //TODO Altri
        state.datiSimulazioniSrl.E153 = getAltri(collabCF)
        
        //Abitazione principale
        state.datiSimulazioniSrl.E154 = getValue("RB010018", collabCF)
        //Redditi a cedolare Secca
        state.datiSimulazioniSrl.E156 = getRedditiCedolareSecca(collabCF)
        
        // Familiari a carico
        // state.datiSimulazioniSrl.H148 = (getValue("FA001001", collabCF) != null || getValue("FA001005", collabCF) != null);
        //Figli, max è 4 calcolo un po' complesso
        // state.datiSimulazioniSrl.J148 = getNumeroFigli(collabCF)
        // % è lo stesso valore 
        state.datiSimulazioniSrl.L148 = getValue("FA002007", collabCF)

        //Oneri deducibili RN023001 - RN021001
        state.datiSimulazioniSrl.L150 = getValue("RN003001", collabCF) - getValue("RN021001", collabCF)
        //Detrazioni per oneri
        state.datiSimulazioniSrl.L151 = getValue("RN022001", collabCF) + getValue("RN023001", collabCF) - getValue("RN008001", collabCF)
        //TODO Soggetto a Contribuzione ivs
        // state.datiSimulazioniSrl.J153 = getContribuzioneIvs(collabCF)
        //Ulteriore redditi di impresa per 
        state.datiSimulazioniSrl.J154 = getValue("RR002003", collabCF) - getValue("RR001003", collabCF)
    }
}

const getImpresaMinoreLavAutonomo = (collabCF: Map<string, string>) => {
    let result: number = (getValue("RE025001", collabCF) + getValue("RG036001", collabCF) 
    + (getValue("RH001007", collabCF) === 1 ? getValue("RH001004", collabCF) : 0)
    + (getValue("RH002007", collabCF) === 1 ? getValue("RH002004", collabCF) : 0)
    + (getValue("RH003007", collabCF) === 1 ? getValue("RH003004", collabCF) : 0) 
    + (getValue("RH004007", collabCF) === 1 ? getValue("RH004004", collabCF) : 0)
    + getValue("RD016001", collabCF) + getValue("RL030001", collabCF))
    console.log('impresa valore autonomo: ' + result);
    return result;
}

const getAltri = (collabCF: Map<string, string>) => {
    let result: number = ((getValue("RH001007", collabCF) === 0 ? getValue("RH001004", collabCF) : 0)
    + (getValue("RH002007", collabCF) === 0 ? getValue("RH002004", collabCF) : 0) 
    + (getValue("RH003007", collabCF) === 0 ? getValue("RH003004", collabCF) : 0) 
    + (getValue("RH004007", collabCF) === 0 ? getValue("RH004004", collabCF) : 0)
    + getValue("RH005004", collabCF) + getValue("RH006004", collabCF) 
    + getValue("RA023011", collabCF) + getValue("RA023012", collabCF)
    + getValue("RL003002", collabCF) + getValue("RL004002", collabCF)
    + getValue("RL019001", collabCF) 
    - getValue("RL014002", collabCF) + getValue("RL014003", collabCF) 
    - getValue("RL015002", collabCF) + getValue("RL015003", collabCF) 
    - getValue("RL016002", collabCF) + getValue("RL016003", collabCF) 
    - (getValue("RL010003", collabCF) === 1 ? (getValue("RL010004", collabCF) - getValue("RL010005", collabCF)) : 0) 
    + getValue("RL022002", collabCF) + getValue("RL032001", collabCF)
    + getValue("RT066001", collabCF) + getValue("RT087001", collabCF)
    + getValue("RM015001", collabCF))     
    console.log('impresa valore autonomo: ' + result);
    return result;
}

const getRedditiCedolareSecca = (collabCF: Map<string, string>) => {
    let result: number = getValue("RL010003", collabCF) === 1 ? 
    (getValue("RB010014", collabCF) + getValue("RB010015", collabCF) + getValue("RL010004", collabCF) - getValue("RL010005", collabCF)) 
    : 0
    return result;
}


/// Function per calolare il numero di figli, not Used at the moment
const getNumeroFigli = (collabCF: Map<string, string>) => {
    let result: number = 0;
    let cf: string = collabCF["FA002004"].value;

    if (cf === collabCF["FA003004"].value && cf === collabCF["FA004004"].value && cf === collabCF["FA005004"].value && cf === collabCF["FA006004"].value)
    {
        result = 1
        return result;
    }   

    result = getValue("FA002001", collabCF) + getValue("FA003001", collabCF) + getValue("FA004001", collabCF) + getValue("FA005001", collabCF) + getValue("FA006001", collabCF)
    if (result > 4) { result = 4 }
    return result;
} 
